import React, { useMemo } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { setupIonicReact } from '@ionic/react';
import { TokenClient, initTokenProvider } from '@sequelae/ui-core';
import './index.css';
import './App.css';
import NotificationsPage from './pages/NotificationsPage';
import PrivacyPage from './pages/PrivacyPage';

// Initialize Ionic React
// Force Ionic React to use the iOS mode for development.
setupIonicReact({ 
  mode: process.env.NODE_ENV === 'development' ? 'ios' : undefined 
});

// Initialize token provider (from @sequelae/ui-core)
initTokenProvider();

/**
 * User Preferences Component (Bridge-Integrated)
 *
 * This component will manage user notification preferences.
 * Exposed via Module Federation as './Preferences' for Bridge integration.
 * 
 * Follows the UI.Streaks pattern: receives tokens from host application.
 */

interface AppProps {
  onModuleFinished?: (mfeType: string, data: any) => void;
  externalRefUserId?: number;
  hostAuthResult?: any;
  onGetAccessToken?: () => Promise<string>;
}

function RootRedirect() {
  const location = useLocation();
  return <Navigate to={`/privacy${location.search}`} replace />;
}

function App({ onModuleFinished, externalRefUserId: refUserId, hostAuthResult, onGetAccessToken }: AppProps) {
  // Prefer hostAuthResult if provided, fallback to TokenClient (following UI.Streaks pattern)
  const accessToken = useMemo(
    () =>
      hostAuthResult?.accessToken ||
      TokenClient.getAccessToken() ||
      undefined,
    [hostAuthResult]
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/privacy" element={<PrivacyPage accessToken={accessToken} refUserId={refUserId} />} />
        <Route path="/notifications" element={<NotificationsPage accessToken={accessToken} />} />
      </Routes>
    </BrowserRouter>
  )
};

export default App;

